/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Get_StartedInputs */

const en_common_get_started = /** @type {(inputs: Common_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const de_common_get_started = /** @type {(inputs: Common_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loslegen`)
};

const fr_common_get_started = /** @type {(inputs: Common_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer`)
};

const es_common_get_started = /** @type {(inputs: Common_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar`)
};

const it_common_get_started = /** @type {(inputs: Common_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia`)
};

const nl_common_get_started = /** @type {(inputs: Common_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aan de slag`)
};

const pl_common_get_started = /** @type {(inputs: Common_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij`)
};

const fi_common_get_started = /** @type {(inputs: Common_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita`)
};

const da_common_get_started = /** @type {(inputs: Common_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom i gang`)
};

const sv_common_get_started = /** @type {(inputs: Common_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom igång`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Common_Get_StartedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_get_started = /** @type {((inputs?: Common_Get_StartedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Get_StartedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_get_started(inputs)
	if (locale === "fr") return fr_common_get_started(inputs)
	if (locale === "es") return es_common_get_started(inputs)
	if (locale === "it") return it_common_get_started(inputs)
	if (locale === "nl") return nl_common_get_started(inputs)
	if (locale === "pl") return pl_common_get_started(inputs)
	if (locale === "fi") return fi_common_get_started(inputs)
	if (locale === "da") return da_common_get_started(inputs)
	if (locale === "sv") return sv_common_get_started(inputs)
	return en_common_get_started(inputs)
});